<div class="modal-backdrop fade show"></div>
<div class="modal fade show" [id]="id" style="display:block;overflow-y:auto" tabindex="-1" role="dialog"
  aria-modal="true" [attr.aria-labelledby]="id + '-title'" [attr.aria-busy]="busy" (click)="backdropClick($event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [id]="id + '-title'"><i class="fa s-icon-edit"></i>&nbsp;{{ titles[kind] }}</h5>
        <button type="button" class="close" aria-label="閉じる" [disabled]="busy" (click)="close()"><span aria-hidden="true">&times;</span></button>
      </div>
      @if (operation.message) {
        <div class="alert alert-warning m-3" [attr.role]="busy ? 'status' : 'alert'">{{ operation.message }}</div>
      }
      @switch (kind) {
        @case ('email') { <app-email-editor [member]="member" [busy]="busy" [blocked]="blocked" (submitted)="submitted.emit($event)" (cancel)="close()" /> }
        @case ('loginId') { <app-login-id-editor [member]="member" [busy]="busy" [blocked]="blocked" (submitted)="submitted.emit($event)" (cancel)="close()" /> }
        @case ('password') { <app-password-editor [member]="member" [busy]="busy" [blocked]="blocked" (submitted)="submitted.emit($event)" (cancel)="close()" /> }
        @case ('emergency') { <app-emergency-contact-editor [member]="member" [busy]="busy" [blocked]="blocked" (submitted)="submitted.emit($event)" (cancel)="close()" /> }
      }
    </div>
  </div>
</div>
